import React from "react"
import { NavLink, useLocation } from "react-router-dom"
import { useRequestNavigate } from "../common/UnsavedChangesGuard.jsx"
import { useNavShell } from "./navShellContext.js"

/**
 * @param {{
 *   label: string,
 *   Icon: React.ComponentType<{ size?: number }>,
 *   route: string,
 *   notImplemented?: boolean,
 *   dimmed?: boolean,
 * }} props
 */
export function NavItemBase({ label, Icon, route, notImplemented = false, dimmed = false }) {
    const { closeSidebar, isCollapsed, onNotImplemented } = useNavShell()
    const requestNavigate = useRequestNavigate()
    const location = useLocation()

    return (
        <NavLink
            to={route}
            onClick={(event) => {
                if (notImplemented) {
                    event.preventDefault()
                    onNotImplemented()
                    closeSidebar()
                    return
                }
                event.preventDefault()
                closeSidebar()
                if (location.pathname === route) {
                    return
                }
                requestNavigate(route)
            }}
            className={({ isActive }) =>
                "btn text-white w-100 d-flex align-items-center text-decoration-none " +
                (isCollapsed ? "justify-content-center " : "") +
                (notImplemented ? " v2-not-implemented-btn " : " ") +
                (isActive ? "bg-white bg-opacity-10 " : "") +
                "border-0"
            }
            style={{
                fontSize: "0.875rem",
                fontWeight: 500,
                padding: isCollapsed ? "1rem 0.5rem" : "0.75rem 1rem",
                borderRadius: "0.5rem",
                opacity: dimmed ? 0.8 : 1,
            }}
            title={isCollapsed ? label : ""}
        >
            <Icon size={isCollapsed ? 28 : 20} />
            <span className={"nav-text" + (isCollapsed ? "" : " ms-2")}>{label}</span>
        </NavLink>
    )
}

